import React from 'react';

import { NumericTextInput, NumericTextInputProps } from '@/components/form-controls/numeric-text-input';

export const CurrencyTextInput = ({ ...props }: NumericTextInputProps) => {
  return <NumericTextInput icon={<>$</>} style={{ paddingLeft: '2rem' }} {...props}/>;
};
